/**
 * author: Patrick Vyn Badiang
 * 
 * Description:
 * Includes the embedded sources from both instagram and youtube
 */

import {useMediaQuery } from "@mui/material";

import BigScreenEvents from "./BigScreenEvents";
import SmallScreenEvents from "./SmallScreenEvents";

// change update pictures here
import update1 from "../pictures/updates/cs39.jpg";
import update2 from "../pictures/updates/d7prac1.png";
import update3 from "../pictures/updates/tinikling.jpg";

function Events() {
    // change corresponding links here
    const link1 = 'https://www.instagram.com/p/DeibE-CvSXn/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==';
    const link2 = 'https://www.instagram.com/p/DeHeyF6P8r0/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==';
    const link3 = 'https://www.instagram.com/p/DdDC-NMPEpP/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==';
    const title1 = 'Culture Show Interest Meeting';
    const title2 = 'D7 Practice';
    const title3 = 'FASA at AASU Culture Show';
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('md'));

    return (
        <div>
            {isSmallScreen ? (
                <SmallScreenEvents
                update1 = {update1}
                update2 = {update2}
                update3 = {update3}
                link1 = {link1}
                link2 = {link2}
                link3 = {link3}
                title1 = {title1}
                title2 = {title2}
                title3 = {title3}/>
            ) : (
                <BigScreenEvents
                update1 = {update1}
                update2 = {update2}
                update3 = {update3}
                link1 = {link1}
                link2 = {link2}
                link3 = {link3}
                title1 = {title1}
                title2 = {title2}
                title3 = {title3}/>
            )}

        </div>

    );

}

export default Events;